import { FC } from "react";
import { IPageBlock } from "../../../types/ui";

export interface IHtmlInlineConfig {
  html: string;
}

const HtmlInlineBlockComponent: FC<IPageBlock> = ({ config }) => {
  const textBlockConfig: IHtmlInlineConfig = config;
  const htmlLayout = textBlockConfig?.html?.replace(/&nbsp;/g, " ");

  return <div dangerouslySetInnerHTML={{ __html: htmlLayout }} />;
};

export default HtmlInlineBlockComponent;
